exports.hostName = "https://patentpendingstudios.com";
